import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/confirmReleaseEnrolmentModal";
import deltas from "../../actions/deltas";

const {SET_CONFIRM_RELEASE_ENROLMENT_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_CONFIRM_RELEASE_ENROLMENT_MODAL_STATE);
